<div class="text-center" *hasPermission="permissionTypes.ModifyBroadcastNotifications">
  <button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon class="menu-button"
              data-testid="show-notification-settings-menu"
              matTooltipPosition="right"
              matTooltip="open notification menu">
      more_horiz
    </mat-icon>
  </button>
</div>
<mat-menu #menu="matMenu">
  <button mat-menu-item
          data-testid="edit-notification"
          (click)="onEditClick()">
    <mat-icon class="dark-grey menu-icon">edit</mat-icon>
    <span class="dark-grey menu-text">Edit</span>
  </button>
</mat-menu>
